@if (showShell) {

  <div class="app-shell">

    <div

      class="nav-backdrop"

      [class.visible]="sideNavOpen"

      (click)="closeSideNav()"

      aria-hidden="true"

    ></div>



    <app-side-nav

      [isOpen]="sideNavOpen"

      (closeSideNav)="closeSideNav()"

    ></app-side-nav>



    <header class="mobile-topbar">

      <button

        type="button"

        class="menu-toggle"

        [class.active]="sideNavOpen"

        (click)="toggleSideNav()"

        [attr.aria-expanded]="sideNavOpen"

        aria-label="Toggle navigation"

      >

        <span class="bar"></span>

        <span class="bar"></span>

        <span class="bar"></span>

      </button>

      <div class="mobile-brand">
        <img src="/images/logo.png" alt="Unplugg Software Solutions" class="mobile-logo" />
        <div class="mobile-brand-text">
          <span class="mobile-brand-title">Unplugg Software Solutions</span>
          <span class="mobile-brand-sub">Inventory Management System</span>
        </div>
      </div>

    </header>

    @if (showSessionWarning()) {
      <div class="session-overlay" role="presentation">
        <div class="session-warning" role="dialog" aria-modal="true" aria-labelledby="idle-title">
          <div class="session-warning-text">
            <i class="bi bi-clock-history"></i>
            <div>
              <div id="idle-title">Are you still using the system?</div>
              <p>There has been no activity for 10 minutes. Choose yes to keep working. If there is no activity for 20 minutes, you will be signed out.</p>
            </div>
          </div>
          <div class="session-warning-actions">
            <button type="button" class="session-btn primary" (click)="extendSession()">
              Yes, I'm still here
            </button>
            <button type="button" class="session-btn" (click)="endIdleSession()">
              Sign out
            </button>
          </div>
        </div>
      </div>
    }

    <main class="main-content">

      <router-outlet />

    </main>

  </div>

} @else {

  <router-outlet />

}


